var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescendingBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.214,
    height: 12.984,
    viewBox: "0 0 23.214 12.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10360",
    "data-name": "Group 10360",
    transform: "translate(0 -3.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14023",
    "data-name": "Path 14023",
    d: "M4.4,11.817,3.181,13.032,3.287,2.388a.53.53,0,0,0-1.06,0L2.12,13.032.905,11.817a.53.53,0,0,0-.75.75l2.12,2.12a.53.53,0,0,0,.75,0l2.12-2.12a.53.53,0,1,0-.75-.75",
    transform: "translate(0 1.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14024",
    "data-name": "Path 14024",
    d: "M38.831,9.29H24.645a.645.645,0,0,1,0-1.29H38.831a.645.645,0,0,1,0,1.29",
    transform: "translate(-16.262 5.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14025",
    "data-name": "Path 14025",
    d: "M36.252,21.29H24.645a.645.645,0,0,1,0-1.29H36.252a.645.645,0,0,1,0,1.29",
    transform: "translate(-16.262 -10.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14026",
    "data-name": "Path 14026",
    d: "M33.673,33.29H24.645a.645.645,0,0,1,0-1.29h9.028a.645.645,0,0,1,0,1.29",
    transform: "translate(-16.262 -26.421)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescendingBlackIcon);
export default __webpack_public_path__ + "static/media/descendingBlackIcon.7dbd5a0451590243a61be4561d48f6b6.svg";
export { ForwardRef as ReactComponent };